import PropTypes from "prop-types";

import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";

/** Centered spinner for panel content while data is loading (devices / readings pattern). */
export default function PanelLoadingState({ size = 28, minHeight = 200, sx }) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ flex: 1, minHeight, width: "100%", minWidth: 0, ...sx }}
    >
      <CircularProgress size={size} />
    </Stack>
  );
}

PanelLoadingState.propTypes = {
  size: PropTypes.number,
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
};
